import type { ReactElement } from 'react'

import { BlogArticle } from './BlogArticle'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

import type { Blog } from '@/types/blog'

type Props = {
  blog: Blog
}
export const BlogArticlePage = ({ blog }: Props) => {
  return <BlogArticle {...blog} />
}

BlogArticlePage.getLayout = function getLayout(page: ReactElement<Props>) {
  const pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム',
  }

  const { _id, title, individualMeta, utilMeta } = page.props.blog
  const meta = individualMeta ?? utilMeta

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: 'ニュースルーム', path: '/news/' },
    { name: '広報ブログ', path: '/news/blog' },
    { name: title, path: '' },
  ]

  return (
    <>
      <Head
        title={title}
        description={meta?.blogUtilMeta?.description || ''}
        ogp={{
          type: 'article',
          title: meta?.title,
          url: `news/blog/${_id}`,
          image: meta?.blogUtilMeta?.ogImage,
        }}
      />
      <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs}>
        {page}
      </TitleLayout>
    </>
  )
}
